export const SELECTION_SCOPE = {
  SELECTED_RECORDS: 'selected_records',
  ALL_RECORDS: 'all_records',
  EXCLUDED_RECORDS: 'excluded_records',
};
